var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { GroupType, GroupTypeEnum } from '@/models/GroupType';
import ErrorHandler from '@/support/ErrorHandler';
let SchoolGroupSettings = class SchoolGroupSettings extends Vue {
    constructor() {
        super(...arguments);
        this.isLoading = true;
        this.groupTypes = [];
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        await this.fetchGroupTypes();
    }
    groupIsEditable(group) {
        return !Object.values(GroupTypeEnum).includes(group.label);
    }
    async fetchGroupTypes() {
        this.isLoading = true;
        try {
            const groups = await new GroupType().all();
            this.groupTypes = groups.map((group) => {
                return {
                    ...group,
                    isEditing: false,
                };
            });
        }
        catch (error) {
            ErrorHandler.network(error);
        }
        finally {
            this.isLoading = false;
        }
    }
    onClickAddGroup() {
        this.groupTypes.unshift(new GroupType({ name: this.$t('settings.group.new_group_type'), is_visible_for_students: false, isEditing: true }));
    }
    async onClickUpdateGroup(group) {
        if (!group.name) {
            return;
        }
        try {
            const payload = {
                name: group.name,
                is_visible_for_students: group.is_visible_for_students,
            };
            if (group.id) {
                await new GroupType({ id: group.id }).update(payload);
            }
            else {
                await new GroupType().create(payload);
            }
            await this.initialize();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onClickDeleteGroup(group) {
        try {
            await new GroupType({ id: group.id }).delete();
            await this.initialize();
        }
        catch (error) {
            // ErrorHandler.alert(error as AxiosError);
            const axiosError = error;
            let errorMessage = '';
            let errorTitle = 'Error';
            if (axiosError.response && axiosError.response.data && axiosError.response.data.errors) {
                errorMessage = axiosError.response.data.errors.message || 'an unknown error occured';
                errorTitle = `${this.$t('settings.group.delete_error')}`;
            }
            ErrorHandler.alert(errorMessage, errorTitle);
        }
    }
};
SchoolGroupSettings = __decorate([
    Component({
        components: {
            LoaderCard,
        },
    })
], SchoolGroupSettings);
export default SchoolGroupSettings;
